import React, { ReactNode } from 'react';
import { InputAdornment, SxProps, TextField, Theme } from '@mui/material';

import { INDETERMINATE_TEXT, IndeterminateValue, isIndeterminate } from '../indeterminate';

interface OwnProps<T extends string | number> {
  readonly property: ReactNode;
  readonly value: T | IndeterminateValue;
  readonly formatter?: (value: T) => string;
  readonly startAdornment?: ReactNode;
  readonly endAdornment?: ReactNode;
  readonly sx?: SxProps<Theme>;
  readonly size?: 'small' | 'medium';

  /**
   * If not specified, will be true
   */
  readonly fullWidth?: boolean;

  readonly multiline?: boolean;
}

export function MaterialPropertyValuePair<T extends string | number>(props: OwnProps<T>) {
  const { value, formatter } = props;

  return (
    <TextField
      variant="outlined"
      sx={props.sx}
      size={props.size ?? 'small'}
      fullWidth={props.fullWidth ?? true}
      multiline={props.multiline}
      margin="normal"
      disabled
      label={props.property}
      value={isIndeterminate(value) ? INDETERMINATE_TEXT : formatter ? formatter(value) : value}
      onFocus={(event) => {
        event.target.select();
      }}
      slotProps={{
        input: {
          startAdornment: props.startAdornment ? (
            <InputAdornment position="start">{props.startAdornment}</InputAdornment>
          ) : null,
          endAdornment: props.endAdornment ? (
            <InputAdornment position="end">{props.endAdornment}</InputAdornment>
          ) : null,
        },
      }}
    />
  );
}
